import React, { useState, useRef, useContext } from "react";
import { ThemeContext } from "../../../../context/ThemeContext";

// ─────────────────────────────────────────────────────────────────────────────
// ICONS
// ─────────────────────────────────────────────────────────────────────────────
const SearchIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="11" cy="11" r="8" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);

const PlusIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

const EyeIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const EditIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
  </svg>
);

const DeleteIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
  </svg>
);

const HideIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
    <line x1="1" y1="1" x2="23" y2="23" />
  </svg>
);

const ShowIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const CloseIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const UploadIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="17 8 12 3 7 8" />
    <line x1="12" y1="3" x2="12" y2="15" />
  </svg>
);

const XIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const PageIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="16" y1="13" x2="8" y2="13" />
    <line x1="16" y1="17" x2="8" y2="17" />
    <polyline points="10 9 9 9 8 9" />
  </svg>
);

const Checkbox = ({ checked, onChange, theme }) => (
  <div
    onClick={onChange}
    style={{
      width: "16px",
      height: "16px",
      borderRadius: "4px",
      border: checked ? `2px solid ${theme.primary}` : `2px solid ${theme.border}`,
      background: checked ? theme.primary : "transparent",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      transition: "all 0.15s ease",
    }}
  >
    {checked && (
      <svg width="9" height="9" viewBox="0 0 12 12" fill="none">
        <path d="M2 6l3 3 5-5" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
      </svg>
    )}
  </div>
);

// ─────────────────────────────────────────────────────────────────────────────
// DEMO DATA
// ─────────────────────────────────────────────────────────────────────────────
const demoPages = [
  { id: 1, sn: 8, name: "Contact Us", title: "Contact Us", content: "<p>Contact us page content goes here...</p>", status: "Active", thumbnail: null, imageUrl: null },
  { id: 2, sn: 7, name: "shipping policy", title: "Shipping Policy", content: "<p>Shipping policy details...</p>", status: "Active", thumbnail: null, imageUrl: null },
  { id: 3, sn: 6, name: "refund policy", title: "Refund Policy", content: "<p>Refund policy information...</p>", status: "Active", thumbnail: null, imageUrl: null },
  { id: 4, sn: 5, name: "cancellation policy", title: "Cancellation Policy", content: "<p>Cancellation policy terms...</p>", status: "Active", thumbnail: null, imageUrl: null },
  { id: 5, sn: 4, name: "Our Certifications", title: "Our Certifications", content: "<p>Our certifications and achievements...</p>", status: "Active", thumbnail: null, imageUrl: null },
  { id: 6, sn: 3, name: "about us", title: "About Us", content: "<p>About our company information...</p>", status: "Active", thumbnail: null, imageUrl: null },
  { id: 7, sn: 2, name: "Terms and conditions", title: "Terms and conditions", content: "<p>Terms and conditions content...</p>", status: "Active", thumbnail: null, imageUrl: null },
  { id: 8, sn: 1, name: "privacy policy", title: "Privacy Policy", content: "<p>Privacy policy details...</p>", status: "Active", thumbnail: null, imageUrl: null },
];

// ─────────────────────────────────────────────────────────────────────────────
// ADD PAGE DIALOG COMPONENT (Theme-Aware)
// ─────────────────────────────────────────────────────────────────────────────
const AddPageDialog = ({ onClose, onSave, editingPage, theme }) => {
  const [formData, setFormData] = useState({
    name: editingPage?.name || "",
    title: editingPage?.title || "",
    content: editingPage?.content || "",
    status: editingPage?.status || "Active",
  });
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(editingPage?.imageUrl || null);
  const [dragActive, setDragActive] = useState(false);
  const fileInputRef = useRef(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleContentChange = (e) => {
    setFormData(prev => ({ ...prev, content: e.target.value }));
  };

  const handleImageChange = (file) => {
    if (file) {
      setImageFile(file);
      const reader = new FileReader();
      reader.onloadend = () => setImagePreview(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const handleFileInput = (e) => {
    const file = e.target.files[0];
    handleImageChange(file);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragActive(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setDragActive(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragActive(false);
    const file = e.dataTransfer.files[0];
    if (file && file.type.startsWith('image/')) {
      handleImageChange(file);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name.trim()) return;
    
    const maxSn = editingPage?.sn || 0;
    onSave({
      name: formData.name,
      title: formData.title || formData.name,
      content: formData.content || "",
      status: formData.status,
      imageFile,
      imageUrl: imagePreview,
      sn: maxSn,
    });
    onClose();
  };

  const inputStyle = {
    width: "100%",
    padding: "12px 14px",
    background: theme.surfaceLighter,
    border: `1px solid ${theme.border}`,
    borderRadius: "12px",
    fontSize: "14px",
    color: theme.textPrimary,
    outline: "none",
    transition: "all 0.2s",
    boxSizing: "border-box",
    fontFamily: "inherit",
  };

  const labelStyle = {
    display: "block",
    marginBottom: "8px",
    fontSize: "12px",
    fontWeight: 600,
    color: theme.textSecondary,
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
        backdropFilter: "blur(8px)",
        animation: "fadeIn 0.2s ease-out",
        padding: "20px",
      }}
      onClick={onClose}
    >
      <div
        style={{
          width: "90%",
          maxWidth: "620px",
          background: theme.surface,
          borderRadius: "20px",
          boxShadow: `0 25px 60px ${theme.primary}30`,
          overflow: "hidden",
          animation: "slideUp 0.3s ease-out",
          border: `1px solid ${theme.border}`,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "18px 24px",
            borderBottom: `1px solid ${theme.border}`,
            background: theme.surfaceLighter,
          }}
        >
          <h3 style={{ fontSize: "20px", fontWeight: 700, color: theme.textPrimary, margin: 0 }}>
            {editingPage ? "Edit Page" : "Add Page"}
          </h3>
          <button
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              color: theme.textMuted,
              padding: "6px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "8px",
              transition: "all 0.2s",
            }}
            onClick={onClose}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = `${theme.error || theme.danger}15`;
              e.currentTarget.style.color = theme.error || theme.danger;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "none";
              e.currentTarget.style.color = theme.textMuted;
            }}
          >
            <CloseIcon />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <div style={{ padding: "24px", maxHeight: "65vh", overflowY: "auto" }}>
            {/* Page Name */}
            <div style={{ marginBottom: "20px" }}>
              <label style={labelStyle}>
                Page Name <span style={{ color: theme.error || theme.danger }}>*</span>
              </label>
              <input
                type="text"
                name="name"
                style={inputStyle}
                placeholder="Enter page name (e.g., About Us, Contact Us)"
                value={formData.name}
                onChange={handleChange}
                required
                autoFocus
                onFocus={(e) => {
                  e.currentTarget.style.borderColor = theme.primary;
                  e.currentTarget.style.boxShadow = `0 0 0 3px ${theme.primary}15`;
                }}
                onBlur={(e) => {
                  e.currentTarget.style.borderColor = theme.border;
                  e.currentTarget.style.boxShadow = "none";
                }}
              />
            </div>

            {/* Page Title */}
            <div style={{ marginBottom: "20px" }}>
              <label style={labelStyle}>Page Title</label>
              <input
                type="text"
                name="title"
                style={inputStyle}
                placeholder="Enter page title (optional, defaults to page name)"
                value={formData.title}
                onChange={handleChange}
                onFocus={(e) => {
                  e.currentTarget.style.borderColor = theme.primary;
                  e.currentTarget.style.boxShadow = `0 0 0 3px ${theme.primary}15`;
                }}
                onBlur={(e) => {
                  e.currentTarget.style.borderColor = theme.border;
                  e.currentTarget.style.boxShadow = "none";
                }}
              />
            </div>

            {/* Thumbnail Upload */}
            <div style={{ marginBottom: "20px" }}>
              <label style={labelStyle}>Thumbnail</label>
              <div
                style={{
                  border: `2px dashed ${dragActive ? theme.primary : theme.border}`,
                  borderRadius: "16px",
                  padding: "20px",
                  textAlign: "center",
                  cursor: "pointer",
                  transition: "all 0.2s",
                  background: dragActive ? `${theme.primary}08` : theme.surfaceLighter,
                  marginTop: "8px",
                }}
                onClick={() => fileInputRef.current?.click()}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
              >
                <input
                  ref={fileInputRef}
                  type="file"
                  accept="image/png, image/jpeg, image/jpg, image/webp"
                  onChange={handleFileInput}
                  style={{ display: "none" }}
                />
                <div style={{ display: "flex", justifyContent: "center", marginBottom: "12px", color: theme.primary }}>
                  <UploadIcon />
                </div>
                <div style={{ fontSize: "14px", fontWeight: 600, color: theme.textPrimary, marginBottom: "6px" }}>
                  {imagePreview ? "Change Image" : "Upload Image"}
                </div>
                <div style={{ fontSize: "11px", color: theme.textMuted }}>
                  PNG, JPG, WebP up to 10MB
                </div>
                {imagePreview && (
                  <img
                    src={imagePreview}
                    alt="Preview"
                    style={{
                      width: "100%",
                      maxHeight: "140px",
                      objectFit: "cover",
                      borderRadius: "12px",
                      marginTop: "16px",
                      border: `1px solid ${theme.border}`,
                    }}
                  />
                )}
              </div>
            </div>

            {/* Page Content */}
            <div style={{ marginBottom: "20px" }}>
              <label style={labelStyle}>Page Content</label>
              <textarea
                name="content"
                style={{ ...inputStyle, minHeight: "150px", resize: "vertical" }}
                placeholder="Enter page content (HTML supported)"
                value={formData.content}
                onChange={handleContentChange}
                onFocus={(e) => {
                  e.currentTarget.style.borderColor = theme.primary;
                  e.currentTarget.style.boxShadow = `0 0 0 3px ${theme.primary}15`;
                }}
                onBlur={(e) => {
                  e.currentTarget.style.borderColor = theme.border;
                  e.currentTarget.style.boxShadow = "none";
                }}
              />
            </div>

            {/* Status */}
            <div style={{ marginBottom: "20px" }}>
              <label style={labelStyle}>Status</label>
              <select
                name="status"
                style={{ ...inputStyle, cursor: "pointer" }}
                value={formData.status}
                onChange={handleChange}
                onFocus={(e) => (e.currentTarget.style.borderColor = theme.primary)}
                onBlur={(e) => (e.currentTarget.style.borderColor = theme.border)}
              >
                <option value="Active">✅ Active</option>
                <option value="Hidden">👁️‍🗨️ Hidden</option>
              </select>
            </div>
          </div>

          {/* Footer */}
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "12px",
              padding: "16px 24px",
              borderTop: `1px solid ${theme.border}`,
              background: theme.surfaceLighter,
            }}
          >
            <button
              type="button"
              style={{
                padding: "10px 20px",
                background: "transparent",
                border: `1px solid ${theme.border}`,
                borderRadius: "10px",
                fontSize: "14px",
                fontWeight: 500,
                color: theme.textPrimary,
                cursor: "pointer",
                transition: "all 0.2s",
              }}
              onClick={onClose}
              onMouseEnter={(e) => (e.currentTarget.style.background = theme.surfaceLighter)}
              onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
            >
              Cancel
            </button>
            <button
              type="submit"
              style={{
                padding: "10px 24px",
                background: theme.primary,
                border: "none",
                borderRadius: "10px",
                fontSize: "14px",
                fontWeight: 600,
                color: "#fff",
                cursor: "pointer",
                boxShadow: `0 4px 12px ${theme.primary}40`,
                transition: "all 0.2s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-1px)";
                e.currentTarget.style.boxShadow = `0 6px 16px ${theme.primary}60`;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = `0 4px 12px ${theme.primary}40`;
              }}
            >
              {editingPage ? "Update Page" : "Save Page"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// SUB-COMPONENTS (Theme-Aware)
// ─────────────────────────────────────────────────────────────────────────────

const StatusBadge = ({ status, theme }) => {
  const config = {
    Active: { bg: `${theme.success}1a`, color: theme.success, dot: theme.success },
    Hidden: { bg: `${theme.textMuted}1a`, color: theme.textMuted, dot: theme.textMuted },
  };
  const c = config[status] || config.Active;
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "5px",
        padding: "4px 10px",
        borderRadius: "20px",
        fontSize: "11px",
        fontWeight: 600,
        background: c.bg,
        color: c.color,
      }}
    >
      <span style={{ width: "5px", height: "5px", borderRadius: "50%", background: c.dot }} />
      {status}
    </span>
  );
};

const ThumbnailPlaceholder = ({ imageUrl, theme }) => (
  <div
    style={{
      width: "40px",
      height: "40px",
      borderRadius: "8px",
      background: `${theme.primary}15`,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "16px",
      border: `1px solid ${theme.border}`,
      overflow: "hidden",
      color: theme.primary,
    }}
  >
    {imageUrl ? (
      <img src={imageUrl} alt="thumbnail" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
    ) : (
      <PageIcon />
    )}
  </div>
);

// ─────────────────────────────────────────────────────────────────────────────
// MAIN COMPONENT (Theme-Aware)
// ─────────────────────────────────────────────────────────────────────────────
const Pages = () => {
  const { theme } = useContext(ThemeContext); // ← Theme Context
  
  const [pages, setPages] = useState(demoPages);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState(new Set());
  const [currentPage, setCurrentPage] = useState(1);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [editingPage, setEditingPage] = useState(null);
  const itemsPerPage = 10;

  // Filter pages
  const filteredPages = pages.filter(page =>
    page.name.toLowerCase().includes(search.toLowerCase()) ||
    page.title.toLowerCase().includes(search.toLowerCase())
  );

  // Pagination
  const totalPages = Math.ceil(filteredPages.length / itemsPerPage);
  const paginatedPages = filteredPages.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  // Selection handlers
  const toggleAll = () => {
    if (selected.size === paginatedPages.length) {
      setSelected(new Set());
    } else {
      setSelected(new Set(paginatedPages.map(p => p.id)));
    }
  };
  const toggleOne = (id) => {
    const newSelected = new Set(selected);
    newSelected.has(id) ? newSelected.delete(id) : newSelected.add(id);
    setSelected(newSelected);
  };

  // Toggle status
  const toggleStatus = (id) => {
    setPages(prev => prev.map(p =>
      p.id === id ? { ...p, status: p.status === "Active" ? "Hidden" : "Active" } : p
    ));
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this page?")) {
      setPages(prev => prev.filter(p => p.id !== id));
      setSelected(prev => {
        const newSet = new Set(prev);
        newSet.delete(id);
        return newSet;
      });
    }
  };

  const handleEdit = (page) => {
    setEditingPage(page);
    setIsDialogOpen(true);
  };

  const handleView = (page) => {
    alert(`📄 Page: ${page.name}\nTitle: ${page.title}\nContent: ${page.content?.substring(0, 100)}...`);
  };

  const handleAddPage = () => {
    setEditingPage(null);
    setIsDialogOpen(true);
  };

  const handleSavePage = (pageData) => {
    if (editingPage) {
      setPages(prev => prev.map(p =>
        p.id === editingPage.id
          ? {
              ...p,
              name: pageData.name,
              title: pageData.title,
              content: pageData.content,
              status: pageData.status,
              imageUrl: pageData.imageUrl || p.imageUrl,
            }
          : p
      ));
    } else {
      const newId = Math.max(...pages.map(p => p.id), 0) + 1;
      const newSn = Math.max(...pages.map(p => p.sn), 0) + 1;
      const newPage = {
        id: newId,
        sn: newSn,
        name: pageData.name,
        title: pageData.title || pageData.name,
        content: pageData.content,
        status: pageData.status,
        imageUrl: pageData.imageUrl,
      };
      setPages(prev => [newPage, ...prev]);
    }
  };

  const styles = {
    container: {
      background: "transparent",
      fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
      padding: "20px 24px",
    },
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "24px",
      flexWrap: "wrap",
      gap: "16px",
    },
    searchWrapper: {
      position: "relative",
      flex: 1,
      maxWidth: "400px",
      minWidth: "250px",
    },
    searchInput: {
      width: "100%",
      padding: "10px 12px 10px 38px",
      background: theme.surface,
      border: `1px solid ${theme.border}`,
      borderRadius: "10px",
      fontSize: "13px",
      color: theme.textPrimary,
      outline: "none",
      transition: "all 0.2s ease",
      boxSizing: "border-box",
    },
    addBtn: {
      display: "flex",
      alignItems: "center",
      gap: "6px",
      padding: "10px 20px",
      background: theme.primary,
      color: "#fff",
      border: "none",
      borderRadius: "10px",
      fontSize: "13px",
      fontWeight: 600,
      cursor: "pointer",
      boxShadow: `0 4px 12px ${theme.primary}40`,
      transition: "all 0.2s ease",
    },
    selectionBar: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
      background: `${theme.primary}15`,
      border: `1px solid ${theme.primary}40`,
      borderRadius: "10px",
      padding: "10px 16px",
      marginBottom: "16px",
    },
    tableWrapper: {
      background: theme.surface,
      border: `1px solid ${theme.border}`,
      borderRadius: "16px",
      overflow: "hidden",
      boxShadow: `0 4px 12px ${theme.primary}08`,
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
      minWidth: "800px",
    },
    th: {
      padding: "14px 16px",
      textAlign: "left",
      fontSize: "11px",
      fontWeight: 700,
      color: theme.primary,
      borderBottom: `1px solid ${theme.border}`,
      background: theme.surfaceLighter,
      whiteSpace: "nowrap",
      textTransform: "uppercase",
      letterSpacing: "0.5px",
    },
    td: {
      padding: "14px 16px",
      fontSize: "13px",
      color: theme.textPrimary,
      borderBottom: `1px solid ${theme.border}`,
    },
    actions: {
      display: "flex",
      gap: "6px",
    },
    nameCell: {
      fontWeight: 600,
      color: theme.textPrimary,
    },
    contentPreview: {
      maxWidth: "200px",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      color: theme.textSecondary,
      fontSize: "12px",
    },
    footer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "14px 20px",
      borderTop: `1px solid ${theme.border}`,
      background: theme.surfaceLighter,
      flexWrap: "wrap",
      gap: "12px",
    },
    pageInfo: {
      fontSize: "12px",
      color: theme.textSecondary,
    },
    pagination: {
      display: "flex",
      gap: "6px",
    },
    emptyState: {
      padding: "60px",
      textAlign: "center",
    },
  };

  return (
    <div style={styles.container}>
      <style>{`
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes slideUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
      `}</style>
      
      {/* Header */}
      <div style={styles.header}>
        <div style={styles.searchWrapper}>
          <span
            style={{
              position: "absolute",
              left: "12px",
              top: "50%",
              transform: "translateY(-50%)",
              color: theme.primary,
              display: "flex",
              alignItems: "center",
            }}
          >
            <SearchIcon />
          </span>
          <input
            type="text"
            style={styles.searchInput}
            placeholder="Search pages..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setCurrentPage(1);
            }}
            onFocus={(e) => {
              e.currentTarget.style.borderColor = theme.primary;
              e.currentTarget.style.boxShadow = `0 0 0 3px ${theme.primary}15`;
            }}
            onBlur={(e) => {
              e.currentTarget.style.borderColor = theme.border;
              e.currentTarget.style.boxShadow = "none";
            }}
          />
          {search && (
            <button
              onClick={() => { setSearch(""); setCurrentPage(1); }}
              style={{
                position: "absolute",
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)",
                background: "none",
                border: "none",
                cursor: "pointer",
                color: theme.textMuted,
                padding: "4px",
                display: "flex",
              }}
            >
              <XIcon />
            </button>
          )}
        </div>
        <button
          style={styles.addBtn}
          onClick={handleAddPage}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-1px)";
            e.currentTarget.style.boxShadow = `0 6px 16px ${theme.primary}60`;
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = `0 4px 12px ${theme.primary}40`;
          }}
        >
          <PlusIcon /> Add Page
        </button>
      </div>

      {/* Selection Bar */}
      {selected.size > 0 && (
        <div style={styles.selectionBar}>
          <span style={{ fontSize: "13px", color: theme.primary, fontWeight: 600 }}>
            ✓ {selected.size} page{selected.size > 1 ? "s" : ""} selected
          </span>
          <div style={{ flex: 1 }} />
          <button
            onClick={() => setSelected(new Set())}
            style={{
              padding: "6px 14px",
              borderRadius: "8px",
              border: `1px solid ${theme.border}`,
              background: theme.surface,
              color: theme.textSecondary,
              fontSize: "12px",
              fontWeight: 500,
              cursor: "pointer",
              transition: "all 0.2s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = theme.surfaceLighter;
              e.currentTarget.style.color = theme.textPrimary;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = theme.surface;
              e.currentTarget.style.color = theme.textSecondary;
            }}
          >
            Clear Selection
          </button>
        </div>
      )}

      {/* Pages Table */}
      <div style={styles.tableWrapper}>
        <div style={{ overflowX: "auto" }}>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>
                  <Checkbox
                    checked={selected.size === paginatedPages.length && paginatedPages.length > 0}
                    onChange={toggleAll}
                    theme={theme}
                  />
                </th>
                <th style={styles.th}>SN</th>
                <th style={styles.th}>Thumbnail</th>
                <th style={styles.th}>Name</th>
                <th style={styles.th}>Title</th>
                <th style={styles.th}>Content</th>
                <th style={styles.th}>Status</th>
                <th style={styles.th}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {paginatedPages.map((page) => (
                <tr
                  key={page.id}
                  style={{
                    background: selected.has(page.id) ? `${theme.primary}10` : "transparent",
                    transition: "background 0.15s ease",
                  }}
                  onMouseEnter={(e) => {
                    if (!selected.has(page.id)) {
                      e.currentTarget.style.background = theme.surfaceHover || theme.surfaceLighter;
                    }
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = selected.has(page.id) ? `${theme.primary}10` : "transparent";
                  }}
                >
                  <td style={styles.td}>
                    <Checkbox checked={selected.has(page.id)} onChange={() => toggleOne(page.id)} theme={theme} />
                  </td>
                  <td style={{ ...styles.td, fontFamily: "monospace", color: theme.textMuted }}>{page.sn}</td>
                  <td style={styles.td}>
                    <ThumbnailPlaceholder imageUrl={page.imageUrl} theme={theme} />
                  </td>
                  <td style={{ ...styles.td, ...styles.nameCell }}>{page.name}</td>
                  <td style={{ ...styles.td, color: theme.textSecondary }}>{page.title}</td>
                  <td style={styles.td}>
                    <div
                      style={styles.contentPreview}
                      dangerouslySetInnerHTML={{
                        __html: page.content?.substring(0, 60) + (page.content?.length > 60 ? "..." : "") || "—"
                      }}
                    />
                  </td>
                  <td style={styles.td}>
                    <StatusBadge status={page.status} theme={theme} />
                  </td>
                  <td style={styles.td}>
                    <div style={styles.actions}>
                      <button
                        style={{
                          background: `${theme.primary}15`,
                          border: `1px solid ${theme.primary}30`,
                          cursor: "pointer",
                          padding: "6px 8px",
                          color: theme.primary,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          borderRadius: "6px",
                          transition: "all 0.2s ease",
                        }}
                        onClick={() => handleView(page)}
                        title="View"
                        onMouseEnter={(e) => (e.currentTarget.style.background = `${theme.primary}25`)}
                        onMouseLeave={(e) => (e.currentTarget.style.background = `${theme.primary}15`)}
                      >
                        <EyeIcon />
                      </button>
                      <button
                        style={{
                          background: `${theme.warning}15`,
                          border: `1px solid ${theme.warning}30`,
                          cursor: "pointer",
                          padding: "6px 8px",
                          color: theme.warning,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          borderRadius: "6px",
                          transition: "all 0.2s ease",
                        }}
                        onClick={() => handleEdit(page)}
                        title="Edit"
                        onMouseEnter={(e) => (e.currentTarget.style.background = `${theme.warning}25`)}
                        onMouseLeave={(e) => (e.currentTarget.style.background = `${theme.warning}15`)}
                      >
                        <EditIcon />
                      </button>
                      <button
                        style={{
                          background: page.status === "Active" ? `${theme.success}15` : `${theme.textMuted}15`,
                          border: `1px solid ${page.status === "Active" ? theme.success : theme.textMuted}30`,
                          cursor: "pointer",
                          padding: "6px 8px",
                          color: page.status === "Active" ? theme.success : theme.textMuted,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          borderRadius: "6px",
                          transition: "all 0.2s ease",
                        }}
                        onClick={() => toggleStatus(page.id)}
                        title={page.status === "Active" ? "Hide" : "Show"}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = page.status === "Active" ? `${theme.success}25` : `${theme.textMuted}25`;
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = page.status === "Active" ? `${theme.success}15` : `${theme.textMuted}15`;
                        }}
                      >
                        {page.status === "Active" ? <HideIcon /> : <ShowIcon />}
                      </button>
                      <button
                        style={{
                          background: `${theme.error || theme.danger}15`,
                          border: `1px solid ${theme.error || theme.danger}30`,
                          cursor: "pointer",
                          padding: "6px 8px",
                          color: theme.error || theme.danger,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          borderRadius: "6px",
                          transition: "all 0.2s ease",
                        }}
                        onClick={() => handleDelete(page.id)}
                        title="Delete"
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = theme.error || theme.danger;
                          e.currentTarget.style.color = "#fff";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = `${theme.error || theme.danger}15`;
                          e.currentTarget.style.color = theme.error || theme.danger;
                        }}
                      >
                        <DeleteIcon />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
              {paginatedPages.length === 0 && (
                <tr>
                  <td colSpan={8}>
                    <div style={styles.emptyState}>
                      <div
                        style={{
                          width: "80px",
                          height: "80px",
                          borderRadius: "50%",
                          background: `${theme.primary}15`,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          margin: "0 auto 16px",
                          color: theme.primary,
                        }}
                      >
                        <PageIcon />
                      </div>
                      <h3 style={{ color: theme.textPrimary, marginBottom: "8px", fontSize: "16px", fontWeight: 600 }}>
                        {search ? "No Matching Pages" : "No Pages Found"}
                      </h3>
                      <p style={{ color: theme.textMuted, fontSize: "13px", margin: 0 }}>
                        {search ? "Try a different search term" : "Create your first page to get started"}
                      </p>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Footer with Rows and Pagination */}
      <div style={styles.footer}>
        <div style={styles.pageInfo}>
          Showing <strong style={{ color: theme.textPrimary }}>{Math.min((currentPage - 1) * itemsPerPage + 1, filteredPages.length)}</strong> to <strong style={{ color: theme.textPrimary }}>{Math.min(currentPage * itemsPerPage, filteredPages.length)}</strong> of <strong style={{ color: theme.textPrimary }}>{filteredPages.length}</strong> pages
        </div>
        <div style={styles.pagination}>
          <button
            style={{
              width: "32px",
              height: "32px",
              borderRadius: "6px",
              border: `1px solid ${theme.border}`,
              background: theme.surface,
              color: currentPage === 1 ? theme.textMuted : theme.textPrimary,
              cursor: currentPage === 1 ? "not-allowed" : "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              opacity: currentPage === 1 ? 0.5 : 1,
              transition: "all 0.2s ease",
            }}
            onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
            disabled={currentPage === 1}
          >
            ‹
          </button>
          {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
            let pageNum;
            if (totalPages <= 5) pageNum = i + 1;
            else if (currentPage <= 3) pageNum = i + 1;
            else if (currentPage >= totalPages - 2) pageNum = totalPages - 4 + i;
            else pageNum = currentPage - 2 + i;
            return pageNum <= totalPages && (
              <button
                key={pageNum}
                style={{
                  width: "32px",
                  height: "32px",
                  borderRadius: "6px",
                  border: currentPage === pageNum ? `1px solid ${theme.primary}` : `1px solid ${theme.border}`,
                  background: currentPage === pageNum ? theme.primary : theme.surface,
                  color: currentPage === pageNum ? "#fff" : theme.textSecondary,
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: currentPage === pageNum ? 700 : 500,
                  fontSize: "12px",
                  transition: "all 0.2s ease",
                }}
                onClick={() => setCurrentPage(pageNum)}
              >
                {pageNum}
              </button>
            );
          })}
          <button
            style={{
              width: "32px",
              height: "32px",
              borderRadius: "6px",
              border: `1px solid ${theme.border}`,
              background: theme.surface,
              color: currentPage === totalPages ? theme.textMuted : theme.textPrimary,
              cursor: currentPage === totalPages ? "not-allowed" : "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              opacity: currentPage === totalPages ? 0.5 : 1,
              transition: "all 0.2s ease",
            }}
            onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
            disabled={currentPage === totalPages}
          >
            ›
          </button>
        </div>
      </div>

      {/* Add/Edit Page Dialog */}
      {isDialogOpen && (
        <AddPageDialog
          onClose={() => {
            setIsDialogOpen(false);
            setEditingPage(null);
          }}
          onSave={handleSavePage}
          editingPage={editingPage}
          theme={theme}
        />
      )}
    </div>
  );
};

export default Pages;